// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"6383cb82","747":"91aea7e8","888":"6e2dad1d"}[chunkId] + ".chunk.js";
};